import styled from '@emotion/styled'
import { MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5, 1),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 28,
  color: theme.palette.text.secondary,
  '& svg': {
    fontSize: theme.typography.h3.fontSize
  }

}))

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  margin: 0,
  '& .MuiTypography-root': {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    fontSize: theme.typography.body1.fontSize,
  },
}))

export {
  StyledMenuItem,
  StyledListItemIcon,
  StyledListItemText,
}
